export default {
    CHANGE_PLAN_LINK: 'USERS.CHANGE_PLAN',
    INCREASE_NOW_LINK: 'USERS.INCREASE_NOW',
    INVITATION_SUCCESS_LABEL: 'USERS.INVITATION_SUCCESS',
    CHANGE_PLAN_SUCCESS_LABEL: 'USERS.CHANGE_PLAN_SUCCESS',
    NO_FREE_SLOTS: "USERS.NO_FREE_SEATS",
    ONE_FREE_SEAT: "USERS.ONE_FREE_SEAT",
    MANY_FREE_SEATS: "USERS.MANY_FREE_SEATS",
    CHANGE_PLAN_PENDING: "USERS.CHANGE_PLAN_PENDING"
};